import React from 'react';
import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../theme/Theme';
import RectBullet from '../assets/landing/rect-bullet.svg';
import { Image } from 'antd';

const Wrapper = styled.div`
    width: 100%;
    .body {
        margin: auto;
        height: 100%;
        width: 100%;
        padding: 40px 20px;
        max-width: 1440px;
        .content {
            flex: 1;
            width: 100%;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                letter-spacing: 2px;
                margin-bottom: 60px;
            }
            .box-content {
                width: 100%;
                max-width: 424px;
                height: 100%;
                aspect-ratio: 1 / 1.5;
                background: rgba(234, 52, 176, 0.08);
                border: 1px solid #ea34b0;
                padding: 24px;
                margin-bottom: 12px;
                border-radius: 8px;
                .title {
                    font-family: 'Joystix';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 17px;
                    text-align: center;
                    color: #0e0c0c;
                }
                .sub-title {
                    font-family: 'Karmatic Arcade';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 24px;
                    line-height: 36px;
                    text-align: center;
                    color: #000000;
                }
                .desc {
                    font-family: 'Joystix';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 32px;
                    color: #585858;
                }
            }
        }
        .content-row {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
        }
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .body {
            .content-row {
                flex-direction: column;
            }
        }
    }
    @media screen and (max-width: ${MEDIA_WIDTHS.upToSmall}px) {
        .body {
            .content {
                .box-content {
                    aspect-ratio: 1 / 2.5;
                }
            }
        }
    }
`;

const TextWithRectBullet = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: start;
    .bullet {
        display: inline-block;
        width: 10px;
        height: 10px;
        display: block;
        margin-top: 12px;
        margin-right: 8px;
        color: black;
    }
`;

const SpaceHeightLarge = styled.div`
    height: 16px;
`;
const SpaceHeightMedium = styled.div`
    height: 8px;
`;
const SpaceHeightSmall = styled.div`
    height: 4px;
`;

const VertLine = styled.div`
    height: 3px;
    width: 155px;
    background: #484848;
    margin: 0 auto;
`;

const BpunksRoadMap = () => {
    return (
        <Wrapper>
            <div className="body">
                <div className="content">
                    <p className="large-title">Roadmap</p>
                    <div className="content-row">
                        <div className="box-content">
                            <p className="title">Pharse 1</p>
                            <SpaceHeightMedium />
                            <VertLine />
                            <SpaceHeightLarge />
                            <p className="sub-title">Foundation and Launch</p>
                            <SpaceHeightLarge />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Establish the core team and community
                            </TextWithRectBullet>
                            <SpaceHeightMedium />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Create and distribute the initial collection of 10,000 BPunk NFTs
                            </TextWithRectBullet>
                        </div>
                        <SpaceHeightLarge />
                        <div className="box-content">
                            <p className="title">Pharse 2</p>
                            <SpaceHeightMedium />
                            <VertLine />
                            <SpaceHeightLarge />
                            <p className="sub-title">Token Issuance, Community Expansion, and Ecosystem Integration</p>
                            <SpaceHeightLarge />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Issue BPunks tokens for community participation and ecosystem growth
                            </TextWithRectBullet>
                            <SpaceHeightMedium />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Integrate BPunks into the Bitcoin ecosystem with collaborations
                            </TextWithRectBullet>
                            <SpaceHeightMedium />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Explore token utility within Trustless Computer and associated dapps
                            </TextWithRectBullet>
                        </div>
                        <SpaceHeightLarge />
                        <div className="box-content">
                            <p className="title">Pharse 3</p>
                            <SpaceHeightMedium />
                            <VertLine />
                            <SpaceHeightLarge />
                            <p className="sub-title">BPunks DAO and Continuous Development</p>
                            <SpaceHeightLarge />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Establish BPunks DAO for decentralized governance Empower token holders to shape the
                                project&apos;s future Foster community engagement through voting and proposals
                            </TextWithRectBullet>
                            <SpaceHeightMedium />
                            <TextWithRectBullet className="desc">
                                <Image className="bullet" preview={false} src={RectBullet} />
                                Continuously improve BPunks based on feedback and trends
                            </TextWithRectBullet>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default BpunksRoadMap;
